import * as yup from "yup";

export const validationSchema = yup.object({
  name: yup
    .string()
    .matches(/^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/, "Solo se permiten letras")
    .max(50, "Debe tener como máximo 50 letras")
    .required("Campo requerido"),
  surname: yup
    .string()
    .matches(/^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/, "Solo se permiten letras")
    .max(50, "Debe tener como máximo 50 letras")
    .required("Campo requerido"),
  health_professional: yup.boolean().required(),
  signature: yup
    .mixed<File>()
    .nullable()
    .when("health_professional", {
      is: true,
      then: (schema) => schema.required("Campo requerido"),
      otherwise: (schema) => schema.nullable(),
    }),
  id_profession: yup
    .number()
    .nullable()
    .when("health_professional", {
      is: true,
      then: () =>
        yup
          .number()
          .min(1, "Selecciona una opción")
          .required("Campo requerido"),
      otherwise: () => yup.number().nullable(),
    }),
  id_registration_type: yup
    .number()
    .nullable()
    .when("health_professional", {
      is: true,
      then: () =>
        yup
          .number()
          .min(1, "Selecciona una opción")
          .required("Campo requerido"),
      otherwise: () => yup.number().nullable(),
    }),
  registration_number: yup
    .string()
    .nullable()
    .when("health_professional", {
      is: true,
      then: () =>
        yup
          .string()
          .matches(/^[0-9]+$/, "Solo se permiten números")
          .max(10, "Debe tener como máximo 10 números")
          .required("Campo requerido"),
      otherwise: () => yup.string().nullable(),
    }),
  document_number: yup
    .string()
    .nullable()
    .when("health_professional", {
      is: true,
      then: () =>
        yup
          .string()
          .matches(/^[0-9]+$/, "Solo se permiten números")
          .min(11, "Debe tener 11 números")
          .max(11, "Debe tener 11 números")
          .required("Campo requerido"),
      otherwise: () => yup.string().nullable(),
    }),
});
